export default "__VITE_ASSET__DCrcB1f$__"